import { Controller } from 'react-hook-form';
import { FormField, SearchField } from '@/components/custom/erp';
import { QUERY_KEYS, vatTuSearchColumns } from '@/constants';
import { statusOptions } from '../../cols-definition';
import { Label } from '@/components/ui/label';
import type { VatTu } from '@/types/schemas';
import { FormMode } from '@/types/form';

interface LotFormProps {
  mode: FormMode;
  vatTu: VatTu | null;
  setVatTu: (vatTu: VatTu) => void;
}

const LotForm: React.FC<LotFormProps> = ({ mode, vatTu, setVatTu }) => {
  return (
    <div className='grid grid-cols-1 gap-2 p-4'>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Mã vật tư</Label>
        <div className='flex items-center'>
          <SearchField
            type='text'
            columnDisplay='ma_vt'
            searchEndpoint={`/${QUERY_KEYS.VAT_TU}/`}
            searchColumns={vatTuSearchColumns}
            displayRelatedField='ten_vt'
            relatedFieldValue={vatTu?.ten_vt || ''}
            dialogTitle='Danh mục vật tư'
            value={vatTu?.ma_vt || ''}
            disabled={mode === 'view'}
            onRowSelection={setVatTu}
          />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Mã lô</Label>
        <div className='w-40'>
          <FormField name='ma_lo' type='text' disabled={mode === 'view'} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Tên lô</Label>
        <div className='w-full'>
          <FormField name='ten_lo' type='text' disabled={mode === 'view'} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Tên khác</Label>
        <div className='w-full'>
          <FormField name='ten_lo2' type='text' disabled={mode === 'view'} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Mã phụ</Label>
        <div className='w-40'>
          <FormField name='ma_vt2' type='text' disabled={mode === 'view'} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Ngày nhập</Label>
        <div className='w-40'>
          <FormField name='ngay_nhap' type='date' disabled={mode === 'view'} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Ngày sản xuất</Label>
        <div className='w-40'>
          <FormField name='ngay_sx' type='date' disabled={mode === 'view'} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Hạn sử dụng</Label>
        <div className='w-40'>
          <FormField name='ngay_hhsd' type='date' disabled={mode === 'view'} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Ngày bảo hành</Label>
        <div className='w-40'>
          <FormField name='ngay_hhbh' type='date' disabled={mode === 'view'} />
        </div>
      </div>

      <div className='mt-2 flex items-start'>
        <Label className='w-40 min-w-40'>Ghi chú</Label>
        <div className='w-full'>
          <Controller
            name='ghi_chu'
            render={({ field }) => (
              <textarea
                {...field}
                value={field.value ?? ''}
                disabled={mode === 'view'}
                rows={2}
                className='w-full rounded-md border-b border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50'
              />
            )}
          />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Trạng thái</Label>
        <div className='w-80'>
          <FormField name='status' type='select' disabled={mode === 'view'} options={statusOptions} />
        </div>
      </div>
    </div>
  );
};

export default LotForm;
